import { formatCurrency, getProductImageUrl } from '../../utils/formatters';

/**
 * Read-only rendering of what the storefront would show for a section.
 * Prices come straight from the API (the real promotion engine), never from the section itself.
 */
const PreviewGrid = ({ preview, isRtl, compact = false }) => {
  if (!preview) return null;
  const locale = isRtl ? 'ar' : 'en';
  const items = preview.items || [];

  return (
    <div className={`cs-preview ${compact ? 'cs-preview--compact' : ''}`}>
      <div className="cs-preview-stats">
        <span className="badge badge-primary">
          {isRtl ? `مثبت: ${preview.pinnedUsed}` : `Pinned: ${preview.pinnedUsed}`}
        </span>
        <span className="badge badge-info">
          {isRtl ? `تلقائي: ${preview.autoFilled}` : `Auto-filled: ${preview.autoFilled}`}
        </span>
        <span className="badge badge-neutral">
          {isRtl ? `الإجمالي في «عرض الكل»: ${preview.totalMatching}` : `Total in "View all": ${preview.totalMatching}`}
        </span>
      </div>

      {(preview.warnings || []).map((w) => (
        <div className="cs-warning" key={w}>
          {w}
        </div>
      ))}

      {items.length === 0 ? (
        <div className="cs-empty">{isRtl ? 'لا توجد منتجات مطابقة.' : 'No matching products.'}</div>
      ) : (
        <div className="cs-preview-grid">
          {items.map((p, i) => {
            const v = [...(p.variants || [])].sort((a, b) => a.price - b.price)[0];
            const img = getProductImageUrl(p.primaryImageUrl);
            const isPinned = i < preview.pinnedUsed;
            return (
              <div className="cs-preview-card" key={p.id}>
                <div className="cs-preview-media">
                  {img ? <img src={img} alt="" loading="lazy" /> : <span className="cs-noimg">—</span>}
                  <span className={`cs-tag ${isPinned ? 'cs-tag--pinned' : ''}`}>
                    {isPinned ? `#${i + 1}` : isRtl ? 'تلقائي' : 'Auto'}
                  </span>
                  {v?.hasDiscount && v.originalPrice > v.price ? (
                    <span className="cs-tag cs-tag--sale">
                      -{Math.round(((v.originalPrice - v.price) / v.originalPrice) * 100)}%
                    </span>
                  ) : null}
                </div>
                <div className="cs-preview-name">{isRtl ? p.nameAr : p.nameEn}</div>
                <div className="cs-preview-meta">{isRtl ? p.brandNameAr : p.brandNameEn}</div>
                {v ? (
                  <div className="cs-preview-price" dir="ltr">
                    {v.hasDiscount && v.originalPrice > v.price ? (
                      <s>{formatCurrency(v.originalPrice, locale)}</s>
                    ) : null}
                    <strong>{formatCurrency(v.price, locale)}</strong>
                    {v.hasFreeShipping ? <em>{isRtl ? 'شحن مجاني' : 'Free ship'}</em> : null}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PreviewGrid;
